import React, { useState, useEffect } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { updateProductItem, getProductItemById } from "../../../redux/reducer/productReducer";
import { fetchMyCarts } from "../../../redux/reducer/cartReducer";

const EditProductModal = ({ item, onClose, onUpdate, direction }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  
  const [formData, setFormData] = useState({ count: "1" });
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (item) {
      setFormData({
        count: item.count || "1",
      });
    }
  }, [item]);

    
  const handleCountChange = (e) => {
    const value = Number(e.target.value);

    if (value > 3) {
      setErrorMsg(t("MaxCountMessage"));
    } else {
      setErrorMsg("");
    }

    const validValue = Math.max(1, Math.min(3, value));
    setFormData({ ...formData, count: validValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedData = {
      count: formData.count,
    };

    dispatch(updateProductItem({ itemId: item._id, data: updatedData }))
      .unwrap()
      .then(() => {
        dispatch(getProductItemById());
        dispatch(fetchMyCarts());
        onClose();
        if (onUpdate) onUpdate();
      })
      .catch((error) => {
        console.error(error);
        alert(t("FailedUpdateItem"));
      });
  };

  if (!item) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30" 
      dir={direction}
    >
      <div className="w-full max-w-lg p-6 mx-4 bg-white rounded-lg shadow-xl md:mx-0">
        <div className="flex justify-between mb-4">
          <h2 className="text-lg font-bold text-black">{t("EditProduct")}</h2>
          <button 
            onClick={onClose}
            className="p-1 transition-colors rounded hover:bg-gray-100"
          >
            <XMarkIcon className="w-6 h-6 text-black" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            {/* Count */}
            <div className="flex items-center justify-between py-2 text-lg border-b lg:py-4">
              <label  className="text-sm font-medium text-black">{t("ProductCount")}</label>

              <div className="flex items-center justify-between ">
                <div className="flex items-center border">
                  <button
                    type="button"
                    className={`px-4 py-2 text-black duration-300 ${formData.count <= 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-200 hover:bg-gray-300'}`}
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        count: Math.max(1, prev.count - 1),
                      }))
                    }
                    disabled={formData.count <= 1}
                  >
                    -
                  </button>
                  <span className="px-4 text-gray-500">{formData.count}</span>
                  <button
                    type="button"
                    className={`px-4 py-2 text-black duration-300 ${formData.count >= 3 ? 'bg-gray-300 cursor-not-allowed' : 'bg-custom-yellow hover:bg-yellow-500'}`}
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        count: Math.min(3, prev.count + 1),
                      }))
                    }
                    disabled={formData.count >= 3}
                  >
                    +
                  </button>
                </div>
              </div>
              {errorMsg && <p className="text-sm text-red-600">{errorMsg}</p>}
            </div>
          </div>
          
          <div className="flex gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 font-bold text-gray-700 duration-300 bg-gray-200 rounded hover:bg-gray-300"
            >
              {t("cancel")}
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-black hover:text-white"
            >
              {t("Update")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProductModal;